//@flow
import React from 'react';

import { translate } from 'react-i18next';
import debounce from 'lodash/debounce';
import { bulkTeamFetch as bulkTeamFetchApi } from 'common/middleware/api';

import EntityIdInput from 'common/entity/generic/EntityIdInput';

import { FilterBuilder, FilterOperation } from 'common/models/internal/Filter';
import DataUtils from 'common/utils/DataUtils';
import FilterListBuilder from 'common/models/helpers/FilterListBuilder';
import { TeamStatusEnum } from 'common/models/internal/MasterTeam';

type Props = {
    clientId: string,
    setSelectedTeam: Object => void,
    selectedTeam: Object,
    entityStatus: ?string,
    t: (string, ?Object) => string,
    testId?: string
};

type State = {
    teams: Array<*>,
    team?: Object
};

const teamInputFilters = (input, status = TeamStatusEnum.Active) => {
    let filters = new FilterListBuilder().addAll([
        new FilterBuilder()
            .withName('status')
            .withOperation(FilterOperation.Equals)
            .withValue(status)
    ]);
    if (!DataUtils.isEmpty(input)) {
        filters = filters.add(
            new FilterBuilder()
                .withName('id')
                .withOperation(FilterOperation.ContainsToken)
                .withValue(input)
        );
    }
    return filters.build();
};

class TeamInput extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            teams: [],
            team: null
        };
        this.loadTeamOptions = debounce(this.loadTeamOptions, 200);
    }

    componentWillUnmount() {
        this.loadTeamOptions.cancel();
    }

    loadTeamOptions = (input: string, callback) => {
        const { clientId, entityStatus } = this.props;
        const filters = teamInputFilters(input, entityStatus);
        bulkTeamFetchApi
            .post({ clientId }, { filters })
            .then((response: Object) => {
                const { teams } = response;
                this.setState({ teams });
                callback(teams);
            })
            .catch(() => {
                //Ignore the error
            });
    };

    onChange = value => {
        const { setSelectedTeam } = this.props;
        setSelectedTeam(value);
    };

    render() {
        const { teams } = this.state;
        const { selectedTeam, testId, t } = this.props;
        return (
            <EntityIdInput
                testId={testId}
                onChange={this.onChange}
                options={teams}
                value={selectedTeam}
                loadOptions={this.loadTeamOptions}
                placeholder={t('teamMasterTable.enableTeamPlaceholder')}
            />
        );
    }
}

export default translate('entityManagement')(TeamInput);
